var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"vx-card",attrs:{"role":"region","aria-label":_vm.title || 'Карточка'}},[(_vm.title)?_c('header',[_c('h4',{staticClass:"vx-card__title"},[_vm._v(_vm._s(_vm.title))])]):_vm._e(),(this.$slots.default)?_c('div',{staticClass:"vx-card__body"},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }